import React,{useEffect,useState} from 'react';
import client from '../../../utils/prismicHelpers';
import * as queries from "../../../utils/prismicQueries";


const InnoFellow = () => {
  const [innoFellowInfo,setInnoFellowInfo] = useState(null);
  useEffect(() => {
      client
          .query({
              query:queries.innoFellow,
          })
          .then((response) => {
              const innoFellowDoc = response.data.allInno_fellows.edges[0].node;
              setInnoFellowInfo(innoFellowDoc);
         

          })
          .catch((error) => {
              console.error(error);
          });
  });

    return (

        <div className="inno-fellow-container">
            <div className=" pt-5">
                <h5 className="fw-bold">{innoFellowInfo?.title[0]?.text}</h5>
                <p>{innoFellowInfo?.description[0]?.text}</p>
                <p><span className="fw-bold"> {innoFellowInfo?.eligibility_title[0]?.text}</span> {innoFellowInfo?.eligibility_description[0]?.text}</p>
                <p><span className="fw-bold">{innoFellowInfo?.criteria_title[0]?.text}</span>  {innoFellowInfo?.criteria_description[0]?.text}</p>
                <p><span className="fw-bold">{innoFellowInfo?. renewal_title[0]?.text}</span>  {innoFellowInfo?.renewal_description[0]?.text}</p>
                <p className="fw-bold">{innoFellowInfo?. work_profile_title[0]?.text}</p>
                <p>{innoFellowInfo?.work_profile_description[0]?.text}</p>
                <p className="fw-bold">{innoFellowInfo?.apply_for_title[0]?.text}</p>
                <ul>
                    {innoFellowInfo?.apply_for.map((info,index)=><li className="body-text" key={index+1}>{info.requires[0]?.text}</li>)}
                        
                </ul>
              
                <p> <span className="fw-bold"> {innoFellowInfo?.stip_duration_title[0]?.text}</span> {innoFellowInfo?. stip_duration_description[0]?.text}</p>
                <p className="fw-bold">{innoFellowInfo?.year_end_title[0]?.text}</p>
                <p>{innoFellowInfo?.year_end_description[0]?.text}.</p>

                <p> <span className="fw-bold">{innoFellowInfo?.apply_text[0]?.text}</span> {innoFellowInfo?.apply_email[0]?.text}</p>

            </div>
        </div>

    );
};

export default InnoFellow;